import { useLocation } from "react-router-dom";

export const AuthError = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const message = params.get("message") || "Unknown error occurred";

  console.error("Auth error:", message);

  return (
    <div className="flex flex-col items-center justify-center h-screen p-4">
      <h1 className="text-3xl font-bold text-red-600 mb-4">
        Authentication Error
      </h1>
      <p className="text-gray-700 mb-6">{message}</p>
      <a
        href="/"
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
      >
        Go Home
      </a>
    </div>
  );
};
